import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60454d23"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-list" }
const _hoisted_2 = {
  key: 0,
  id: "pinned-items"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_4 = { class: "server-name-active" }
const _hoisted_5 = { class: "item-location" }
const _hoisted_6 = { class: "updated-time" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { id: "active-items" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Active", -1))
const _hoisted_10 = { class: "server-name-active" }
const _hoisted_11 = { class: "item-location" }
const _hoisted_12 = { class: "updated-time" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { id: "inactive-items" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Inactive", -1))
const _hoisted_16 = { class: "inactive-items" }
const _hoisted_17 = { class: "updated-time" }
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.pinnedItems.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pinnedItems, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id,
                class: "item"
              }, [
                _createElementVNode("p", _hoisted_4, [
                  _createElementVNode("strong", null, _toDisplayString(item.server.name), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("p", {
                    class: _normalizeClass({ italic: item.location.en_us === 'Inactive' })
                  }, _toDisplayString(item.location.en_us), 3)
                ]),
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.formatDate(item.date_updated)), 1)
                ]),
                _createElementVNode("button", {
                  class: "pin-button",
                  onClick: ($event: any) => (_ctx.unpinItem(item))
                }, "★", 8, _hoisted_7)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeItems, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.id,
            class: "item"
          }, [
            _createElementVNode("p", _hoisted_10, [
              _createElementVNode("strong", null, _toDisplayString(item.server.name), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", null, _toDisplayString(item.location ? item.location.en_us : "Unknown"), 1)
            ]),
            _createElementVNode("span", _hoisted_12, [
              _createElementVNode("i", null, _toDisplayString(_ctx.formatDate(item.date_updated)), 1)
            ]),
            _createElementVNode("button", {
              class: "pin-button",
              onClick: ($event: any) => (_ctx.pinItem(item))
            }, "☆", 8, _hoisted_13)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("ul", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inactiveItems, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.id,
            class: "inactive-items"
          }, [
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, _toDisplayString(item.server.name), 1),
              _createElementVNode("span", _hoisted_17, [
                _createElementVNode("i", null, "  Last updated: " + _toDisplayString(_ctx.formatDate(item.date_updated)), 1)
              ])
            ]),
            _createElementVNode("button", {
              class: "pin-button",
              onClick: ($event: any) => (_ctx.pinItem(item))
            }, "☆", 8, _hoisted_18)
          ]))
        }), 128))
      ])
    ])
  ]))
}